import {Button, Pagination, PaginationItem} from '@mui/material'
import {styled} from '@mui/material/styles'
import PropTypes from 'prop-types'

export const StyledPagination = styled(Pagination)(({theme}) => ({
  '& .MuiPaginationItem-root': {
    margin: '0px',
    fontSize: '14px'
  }
}))

export const StyledButton = styled(Button)(({theme}) => ({
  fontSize: '14px',
  color: theme.palette.common.white,
  textTransform: 'none',
  ':disabled': {
    color: 'grey'
  }
}))

export const StyledDiv = styled('div', {shouldForwardProp: (prop) => prop !== 'changePosition'})(
  ({changePosition}) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: changePosition ? 'auto' : '16px'
  })
)

const PreviousButton = ({page, handlePreviousNumberClick}) => {
  return (
    <StyledButton disabled={page === 1 || page === 0} onClick={handlePreviousNumberClick} aria-label="previous page">
      &lt;&lt; &nbsp;&nbsp;Prev
    </StyledButton>
  )
}

const NextButton = ({count, page, rowsPerPage, handleNextNumberClick}) => {
  return (
    <StyledButton
      disabled={count === 0 || page >= Math.ceil(count / rowsPerPage)}
      onClick={handleNextNumberClick}
      aria-label="next page"
    >
      Next &nbsp;&nbsp;&gt;&gt;
    </StyledButton>
  )
}

const CustomPagination = (props) => {
  const {count, page, onChangePage, rowsPerPage, changePosition = false} = props

  const handlePreviousNumberClick = () => {
    onChangePage(null, page - 1)
  }
  const handleNextNumberClick = () => {
    onChangePage(null, page + 1)
  }

  const handlePageNumberClick = (event, value) => {
    onChangePage(null, value)
  }

  return (
    <StyledDiv changePosition={changePosition}>
      <PreviousButton page={page} handlePreviousNumberClick={handlePreviousNumberClick} />
      <StyledPagination
        color="standard"
        count={Math.ceil(count / rowsPerPage)}
        page={page === 0 ? page + 1 : page}
        onChange={handlePageNumberClick}
        renderItem={(item) => {
          if (item.type === 'previous' || item.type === 'next') {
            return <></> // Return empty fragment to hide previous and next buttons
          }
          return (
            <PaginationItem
              {...item}
              sx={{
                ...(item.type === 'page' && {
                  color: item.selected ? (theme) => theme.palette.common.white : (theme) => theme.palette.common.grey
                }),
                fontSize: '14px'
              }}
            />
          )
        }}
      />
      <NextButton count={count} page={page} rowsPerPage={rowsPerPage} handleNextNumberClick={handleNextNumberClick} />
    </StyledDiv>
  )
}

CustomPagination.propTypes = {
  count: PropTypes.number,
  page: PropTypes.number,
  onChangePage: PropTypes.func,
  rowsPerPage: PropTypes.number,
  changePosition: PropTypes.bool
}

NextButton.propTypes = {
  count: PropTypes.number,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  handleNextNumberClick: PropTypes.func
}

PreviousButton.propTypes = {
  page: PropTypes.number,
  handlePreviousNumberClick: PropTypes.func
}

export default CustomPagination
